import validate from '../../../services/reduxValidate.js'

export default function (data) {

  return validate(data, {
    'freelance.date_cdi_start': { presence: { allowEmpty: false } },
  })
}